export default __webpack_public_path__ + "static/media/banner.b160f703.png";